export interface GalleryItem {
  id: string;
  src: string;
  alt: string;
  caption?: string;
  category: 'portrait' | 'performance';
  aspectRatio: 'portrait' | 'landscape' | 'squarish';
}

export const galleryItems: GalleryItem[] = [
  // Group 1: 3 portraits + 3 landscapes (rows 1-3)
  {
    id: 'gal-1',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/7643e198-6b41-4f60-9590-b12f84ef7e63_compressed_Blue-Suit-3.webp',
    alt: 'Keaton Brown — Portrait in Blue Suit',
    caption: 'Keaton Brown — Baritone',
    category: 'portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-2',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/45b9fe19-3203-48c7-8c2a-3ff98b8d3313_compressed_IMG_5346.webp',
    alt: 'Keaton Brown in Don Giovanni',
    caption: 'Seagle Festival — Don Giovanni',
    category: 'performance',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-3',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/e08cb758-9f80-4c8e-a95d-551e8490ede5_compressed_IMG_5381.webp',
    alt: 'Keaton Brown as Don Giovanni',
    caption: 'Seagle Festival — Don Giovanni',
    category: 'performance',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-4',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/94d64c22-2ed4-4dc5-ab7c-b2c7baff4fdd_compressed_IMG_5388.webp',
    alt: 'Keaton Brown in Don Giovanni',
    caption: 'Seagle Festival — Don Giovanni',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-5',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/37840498-c00d-4425-9b6e-84604de2978b_compressed_SE248063.webp',
    alt: 'Keaton Brown as Boatswain in HMS Pinafore',
    caption: 'Nashville Opera — HMS Pinafore',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-8',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/59f12f17-6013-4c55-9fa6-2ba7faadf70e_compressed_SE248573.webp',
    alt: 'Keaton Brown with Nashville Opera — HMS Pinafore',
    caption: 'Nashville Opera — HMS Pinafore',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  // Group 2: 3 portraits + 3 landscapes (rows 4-6)
  {
    id: 'gal-6',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/9f9796c5-372a-4213-857e-75ad0f4fc1c1_compressed_About-Page.webp',
    alt: 'Keaton Brown — Portrait',
    caption: 'Keaton Brown — Baritone',
    category: 'portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-7',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/585ae5b9-a6af-43fa-96dd-3d0fcc5623d5_compressed_Contact-Page4.webp',
    alt: 'Keaton Brown — Portrait',
    caption: 'Keaton Brown — Baritone',
    category: 'portrait',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-9',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/9a3b858a-ac05-4105-a6ff-2196acbccde4_compressed_SE248080.webp',
    alt: 'Keaton Brown in HMS Pinafore',
    caption: 'Nashville Opera — HMS Pinafore',
    category: 'performance',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-10',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/ac558317-ec60-49f8-ab3c-0bab56f574c8_compressed_SE248361.webp',
    alt: 'Keaton Brown with Nashville Opera — HMS Pinafore Ensemble',
    caption: 'Nashville Opera — HMS Pinafore',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-11',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/e889405d-8988-4251-9560-e23de4620c85_compressed_SE248066.webp',
    alt: 'Keaton Brown with the HMS Pinafore Sailors',
    caption: 'Nashville Opera — HMS Pinafore',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-14',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/63307976-2bb0-437c-a7ff-5abcb33aaae0_compressed_webp.webp',
    alt: 'Keaton Brown — Portrait in Gray Suit',
    caption: 'Keaton Brown — Baritone',
    category: 'portrait',
    aspectRatio: 'landscape',
  },
  // Group 3: 3 portraits + 3 landscapes (rows 7-9)
  {
    id: 'gal-18',
    src: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/f3b3a694-c040-4eb6-ade9-179dd470be0d_compressed_Fiddler-Production-Photo-1-.webp',
    alt: 'Keaton Brown in Fiddler on the Roof — Opera North',
    caption: 'Opera North — Fiddler on the Roof',
    category: 'performance',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-20',
    src: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/8474cb51-4a2c-4286-ae3f-1c3a2551aee3_compressed_Fiddler-Production-Photo-3.webp',
    alt: 'Keaton Brown in Fiddler on the Roof — Opera North',
    caption: 'Opera North — Fiddler on the Roof',
    category: 'performance',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-22',
    src: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/ab94df27-d886-4d28-8d97-4ef900812c0a_compressed_Fiddler-Production-Photo-7-.webp',
    alt: 'Keaton Brown in Fiddler on the Roof — Opera North',
    caption: 'Opera North — Fiddler on the Roof',
    category: 'performance',
    aspectRatio: 'portrait',
  },
  {
    id: 'gal-15',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/ef7f13b5-691e-4949-bc91-0f54e32fffa1_compressed_Cozy-1.webp',
    alt: 'Keaton Brown in Cozy — HOPERA HTX',
    caption: 'HOPERA HTX — Cozy',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-16',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/709a4ab5-6e40-4217-92a4-69acbc3b915f_compressed_Cozy-2-.webp',
    alt: 'Keaton Brown in Cozy — HOPERA HTX',
    caption: 'HOPERA HTX — Cozy',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-17',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/0a620670-4202-45d2-8875-2f9f1876b88e_compressed_Cozy-9-.webp',
    alt: 'Keaton Brown in Cozy — HOPERA HTX',
    caption: 'HOPERA HTX — Cozy',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  // Group 4: 3 landscapes (row 10 — clean bottom row)
  {
    id: 'gal-13',
    src: 'https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/a32a86a0-e919-4a55-bc85-43a8626d3a52_compressed__DSC2062_Original.webp',
    alt: 'Keaton Brown on Stage',
    caption: 'Seagle Festival — Don Giovanni',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-19',
    src: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/094accad-2acf-42eb-be4a-5564c06e44c9_compressed_Fiddler-Production-Photo-2-.webp',
    alt: 'Keaton Brown in Fiddler on the Roof — Opera North',
    caption: 'Opera North — Fiddler on the Roof',
    category: 'performance',
    aspectRatio: 'landscape',
  },
  {
    id: 'gal-21',
    src: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/ef2bd985-e1dc-4b11-b132-1abd5ce73a94_compressed_Fiddler-Production-Photo-5-.webp',
    alt: 'Keaton Brown in Fiddler on the Roof — Opera North',
    caption: 'Opera North — Fiddler on the Roof',
    category: 'performance',
    aspectRatio: 'landscape',
  },
];